module.exports = __webpack_public_path__ + "img/layer-bg_03.0914ad69.jpg";